module.exports = __webpack_public_path__ + "6654e031d1e0af05d08d3acae2801f55.png";